module.exports = __webpack_public_path__ + "static/img/06大哭.7955583.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/06大哭.gif
// module id = Wvpy
// module chunks = 0